module.exports = __webpack_public_path__ + "img/nvidia.4f5d835b.png";